import {Card} from './Card'
import compareCards from './compareCards'
import {removeItem} from '../Array'
import getLowCard from './getLowCard'

// Возвращает TRUE при успешной атаке (соперник не может отбиться)
function checkAttack(
    attackCards: Card[],
    userCards: Card[],
    trump: Card
): boolean {
    attackCards = attackCards.slice()
    userCards = userCards.slice()

    for (let i = 0; i < attackCards.length; i++) {
        const attackCard = attackCards[i]
        const highCards = userCards.filter((userCard: Card) => {
            return compareCards(attackCard, userCard, trump)
        })
        if (!highCards.length) {
            return true
        }
        const lowCard = getLowCard(highCards, trump)
        userCards = removeItem(userCards, lowCard)
    }
    return false
}

export default checkAttack
